// extracted by mini-css-extract-plugin
export var flexContainer = "project-list-module--flex-container--7mxNx";
export var projectList = "project-list-module--project-list--rbdEB";
export var projectThumbnail = "project-list-module--project-thumbnail--Xi7gk";
export var singleRow = "project-list-module--single-row--uTbUn";